import { Link } from 'react-router-dom';

type FooterLink = { to: string; label: string; external?: boolean };

const footerLinks: { title: string; links: FooterLink[] }[] = [
  {
    title: 'Product',
    links: [
      { to: '/ai-resume-builder', label: 'AI Resume Builder' },
      { to: '/ats-resume-builder', label: 'ATS Resume Builder' },
      { to: '/resume-templates', label: 'Resume Templates' },
      { to: '/pricing', label: 'Pricing' },
    ],
  },
  {
    title: 'For You',
    links: [
      { to: '/how-it-works', label: 'How It Works' },
      { to: '/resume-builder-for-students', label: 'Students' },
      { to: '/resume-builder-for-no-experience', label: 'No Experience' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { to: '/privacy', label: 'Privacy Policy' },
      { to: '/terms', label: 'Terms of Service' },
      { to: '/contact', label: 'Contact' },
    ],
  },
];

export function Footer() {
  return (
    <footer className="border-t border-white/[0.08] bg-[#0A2540]">
      <div className="mx-auto max-w-[1200px] px-6 py-16 md:py-20">
        <div className="grid gap-10 md:grid-cols-4">
          <div>
            <span className="text-xl font-bold text-[#00D4AA]">ai-free-resume</span>
            <p className="mt-4 text-sm text-white/65">
              Free PDF resume builder. No sign-up. Private by default.
            </p>
          </div>
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-white">{group.title}</h4>
              <ul className="mt-4 space-y-2 text-sm text-white/65">
                {group.links.map((link) => (
                  <li key={link.to + link.label}>
                    {link.external ? (
                      <a
                        href={link.to}
                        className="transition-colors hover:text-[#00D4AA]"
                      >
                        {link.label}
                      </a>
                    ) : (
                      <Link
                        to={link.to}
                        className="transition-colors hover:text-[#00D4AA]"
                      >
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-white/[0.08] pt-8 md:flex-row">
          <p className="text-sm text-white/55">
            © {new Date().getFullYear()} ai-free-resume. All rights reserved.
          </p>
          <p className="text-sm text-white/55">
            Free PDF download. No sign-up required.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
